import React, { memo } from 'react';
import styled from '@emotion/styled';

import { LOCAL_LANGUAGE } from '@/constants/storageKey';
import { FooterBottom, FooterTop } from '@/components/shared/footer/index';
import { mq } from '@/utils/mediaQuery';
// import { useGetFooterInformation } from '@/hooks/CommonRequests';
import { CommonContainer } from '@/components/container';
import {
  staticFooterAddress,
  staticFooterContact,
  staticFooterMenu,
  staticFooterSns,
} from '@/static/static';

const FooterContainer = styled.footer(({ theme }) => ({
  position: 'relative',
  height: '100%',
  marginTop: '6rem',
  backgroundColor: '#E4E2DF',
  backgroundImage: `url(${theme.image.footerBackgroundMobile})`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: '115% 100%',
  fontSize: '1.4rem',
  lineHeight: '1.5em',
  zIndex: 100,

  [mq('tablet')]: {
    backgroundSize: '100% auto',
  },

  [mq('desktop')]: {
    backgroundImage: `url(${theme.image.footerBackground})`,
    padding: 0,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundColor: theme.color.point01,
  },
}));

const Footer = () => {
  // const [
  //   { data: footerAddress },
  //   { data: footerMenu },
  //   { data: footerContact },
  //   { data: footerSns },
  // ] = useGetFooterInformation();

  const currentLanguage = localStorage.getItem(LOCAL_LANGUAGE)
    ? localStorage.getItem(LOCAL_LANGUAGE)
    : 'en';

  return (
    <FooterContainer>
      <CommonContainer>
        <FooterTop
          // footerAddress={footerAddress}
          // footerMenu={footerMenu}
          // footerContact={footerContact}
          footerAddress={staticFooterAddress[currentLanguage]}
          footerMenu={staticFooterMenu[currentLanguage]}
          footerContact={staticFooterContact[currentLanguage]}
        />
      </CommonContainer>

      <FooterBottom
        // footerAddress={footerAddress}
        // footerSns={footerSns}
        footerAddress={staticFooterAddress[currentLanguage]}
        footerSns={staticFooterSns[currentLanguage]}
      />
    </FooterContainer>
  );
};

export default memo(Footer);
